
        var result = require("!!../../../../node_modules/css-loader/index.js!./tender.alert.profile.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/account.management/tender.alert.profile.component.css
// module id = 272
// module chunks = 0